var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCameraIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  className: "dd-privacy-hidden"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 15,
  cy: 15,
  r: 15,
  fill: "#82B1B0"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M10.5 19.5c-.344 0-.638-.122-.883-.367a1.204 1.204 0 0 1-.367-.883v-7.5c0-.344.122-.638.367-.883s.54-.367.883-.367H18c.344 0 .638.122.883.367s.367.54.367.883v2.813l1.969-1.97c.104-.103.218-.13.343-.077.125.052.188.15.188.296v5.376c0 .145-.063.244-.188.296-.125.052-.24.026-.343-.078l-1.969-1.968v2.812c0 .344-.122.638-.367.883A1.204 1.204 0 0 1 18 19.5h-7.5Z",
  fill: "#fff"
})));
export default SvgCameraIcon;